import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { CSIconButtonComponent } from 'src/app/shared/components/cs-icon-button/cs-icon-button.component';
import { CsConfirmPopupComponent } from 'src/app/shared/components/cs-popup/cs-confirm-popup/cs-confirm-popup.component';
import { Verify2FAComponent } from 'src/app/shared/components/verify-2fa/verify-2fa.component';
import { AddEditAddressComponent } from './add-edit-address/add-edit-address.component';
import { AddressQrComponent } from './address-qr/address-qr.component';
import { DepositTransactionDetailsComponent } from './deposit-transaction-details/deposit-transaction-details.component';
import { DepositWithdrawComponent } from './deposit-withdraw/deposit-withdraw.component';
import { FirstDepositComponent } from './first-deposit/first-deposit.component';
import { SavedAddressComponent } from './saved-address/saved-address.component';
import { WalletDetailsComponent } from './wallet-details/wallet-details.component';
import { WalletDialogType, WalletService } from './wallet.service';

@Component({
  standalone: true,
  selector: 'wallet-dialog',
  templateUrl: './wallet-dialog.html',
  styleUrls: ['./wallet-dialog.scss'],
  imports: [
    CommonModule,
    FirstDepositComponent,
    DepositWithdrawComponent,
    CSIconButtonComponent,
    AddressQrComponent,
    SavedAddressComponent,
    AddEditAddressComponent,
    WalletDetailsComponent,
    Verify2FAComponent,
    CsConfirmPopupComponent,
    DepositTransactionDetailsComponent,
  ],
})
export class WalletDialogComponent {
  constructor(protected walletService: WalletService) {}

  readonly walletDialogType = WalletDialogType;
}
